export const PUBLIC_EQUIPMENT_SELECT = [
  "id",
  "price_brl",
  "stock_quantity_br",
  "visible_br",
  "category_id",
  "name",
  "slug",
  "short_description",
  "description",
  "specifications",
  "price",
  "image_url",
  "gallery",
  "is_featured",
  "is_active",
  "created_at",
  "updated_at",
  "social_links",
  "allow_financing",
  "seo_title",
  "seo_description",
  "seo_og_title",
  "seo_og_description",
  "sku",
  "seo_keywords",
  "mpn",
  "gtin",
  "show_public_price",
  "is_promotion",
  "promotion_label",
  "promotion_ends_at",
  "promotion_max_units",
  "promotion_sold_units",
  "ean",
  "stock_quantity",
  "price_match_enabled",
  "is_visible",
  "location_id",
  "brand",
  "brochure_url",
  "name_en",
  "name_es",
  "name_fr",
  "name_pl",
  "short_description_en",
  "short_description_es",
  "short_description_fr",
  "short_description_pl",
  "description_en",
  "description_es",
  "description_fr",
  "description_pl",
  "promotion_label_en",
  "promotion_label_es",
  "promotion_label_fr",
  "promotion_label_pl",
  "seo_title_en",
  "seo_title_es",
  "seo_title_fr",
  "seo_title_pl",
  "seo_description_en",
  "seo_description_es",
  "seo_description_fr",
  "seo_description_pl",
].join(", ");

export const PUBLIC_EQUIPMENT_WITH_CATEGORY_SELECT = `${PUBLIC_EQUIPMENT_SELECT}, equipment_categories(name, slug)`;

export const PUBLIC_CONSUMABLE_SELECT = [
  "id",
  "price_brl",
  "stock_quantity_br",
  "visible_br",
  "category_id",
  "subcategory_id",
  "name",
  "slug",
  "sku",
  "ean",
  "short_description",
  "description",
  "specifications",
  "price",
  "stock_quantity",
  "min_order_quantity",
  "image_url",
  "gallery",
  "is_active",
  "is_visible",
  "is_featured",
  "is_service",
  "is_promotion",
  "promotion_label",
  "promotion_ends_at",
  "promotion_max_units",
  "promotion_sold_units",
  "show_public_price",
  "price_match_enabled",
  "has_variants",
  "usage_rate",
  "operational_guide",
  "performance_metrics",
  "certifications",
  "weight_kg",
  "created_at",
  "updated_at",
  "location_id",
  "name_en",
  "name_es",
  "name_fr",
  "name_pl",
  "short_description_en",
  "short_description_es",
  "short_description_fr",
  "short_description_pl",
  "description_en",
  "description_es",
  "description_fr",
  "description_pl",
  "promotion_label_en",
  "promotion_label_es",
  "promotion_label_fr",
  "promotion_label_pl",
].join(", ");

export const PUBLIC_CONSUMABLE_VARIANT_SELECT = [
  "id",
  "price_brl",
  "stock_quantity_br",
  "visible_br",
  "consumable_id",
  "name",
  "sku",
  "ean",
  "price",
  "stock_quantity",
  "image_url",
  "attributes",
  "display_order",
  "is_active",
  "created_at",
  "updated_at",
  "weight_kg",
  "min_order_quantity",
  "location_id",
  "name_en",
  "name_es",
  "name_fr",
  "name_pl",
].join(", ");

export const PUBLIC_CONSUMABLE_WITH_CATEGORY_SELECT = `${PUBLIC_CONSUMABLE_SELECT}, consumables_categories(name, slug)`;
export const PUBLIC_CONSUMABLE_WITH_CATEGORY_FULL_SELECT = `${PUBLIC_CONSUMABLE_SELECT}, consumables_categories(*)`;
export const PUBLIC_CONSUMABLE_WITH_VARIANTS_SELECT = `${PUBLIC_CONSUMABLE_SELECT}, consumable_variants(id, stock_quantity, is_active, price, display_order)`;
